import React, { FC } from "react";

import { Icon, Typography } from "ui-library/atoms";
import { Box, Flexbox } from "ui-library/layouts";

export interface WarningMessageProps {
    message: string;
}

export const WarningMessage: FC<WarningMessageProps> = ({ message }) => (
    <Flexbox>
        <Box mt={0.2} mr={0.5}>
            <Icon className="tooltip" size={16} icon={"alert"} color="orange" />
        </Box>
        <Typography variant="h4" color="orange" markDown={message} />
    </Flexbox>
);
